<template>
  <card
      style="min-height:85vh;"
      v-loading="isLoading"
      element-loading-text="Loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.9)"
      >
    <h4> {{title}} </h4>
    <h5 v-if="hasSearchResult" >
      Search Criteria: {{ queryInfo }}
    </h5>
    <hr/>
    <el-form
      v-if="!hasSearchResult"
      :label-position="labelPosition"
      label-width="300px"
      :model="formLabelAlign"
      @submit.prevent="search"
    >

      <el-form-item	label="File Sequence"  >
        <el-select
          class="select-primary mb-3 pagination-select"
          clearable
          style="width:300px"
          v-model="formValue.fileSequence"
          filterable
        >
          <el-option
            class="select-primary"
            v-for="item in master.fileSequence"
            :key="item.FileSeq"
            :label="item.FileSeqName"
            :value="item.FileSeq">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item	label="File Type"  >
        <el-select
          class="select-primary mb-3 pagination-select"
          clearable
          style="width:300px"
          v-model="formValue.fileType"
          filterable
        >
          <el-option
            class="select-primary"
            v-for="item in master.fileType"
            :key="item.FileType + item.FileTypeName"
            :label="item.FileTypeName"
            :value="item.FileType">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item	label="File Series"  >
        <base-input
          class="select-primary mb-3 pagination-select"
          style="width:300px"
          v-model="formValue.fileSer"
        ></base-input>
      </el-form-item>

      <el-form-item	label="File Number"  >
        <base-input
          class="select-primary mb-3 pagination-select"
          style="width:300px"
          type="number"
          v-model="formValue.fileNbr"
        ></base-input>
      </el-form-item>

      <el-form-item	label="File Nbr Range"  >
        <base-input
          class="select-primary mb-3 pagination-select"
          style="width:300px"
          type="number"
          v-model="formValue.fileNbrRange"
        ></base-input>
      </el-form-item>

      <el-form-item	label="File Nbr To"  >
        <base-input
          class="select-primary mb-3 pagination-select"
          style="width:300px"
          type="number"
          v-model="formValue.fileNbrTo"
        ></base-input>
      </el-form-item>


      <el-form-item	label="Application Type & Sub Type"  >
        <el-select
          class="select-primary mb-3 pagination-select"
          clearable
          style="width:300px"
          v-model="formValue.applSubType"
          filterable
        >
          <el-option
            class="select-primary"
            v-for="item in master.applSubType"
            :key="item.ApplTyp + item.ApplSubTyp"
            :label="item.ApplSubTypName"
            :value="item.ApplTyp + '///' + item.ApplSubTyp">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
          label="File Filing Date Range"
          style="width:600px;"
      >
        <el-date-picker
          format="dd/MM/yyyy"
          v-model="formValue.fileFilingDateRange"
        ></el-date-picker>
      </el-form-item>

      <el-form-item
          label="File Filing Date To"
          style="width:600px;"
      >
        <el-date-picker
          format="dd/MM/yyyy"
          v-model="formValue.fileFilingDateTo"
        ></el-date-picker>
      </el-form-item>

      <el-form-item
          label="File Reception Date Range"
          style="width:600px;"
      >
        <el-date-picker
          format="dd/MM/yyyy"
          v-model="formValue.fileReceptionDateRange"
        ></el-date-picker>
      </el-form-item>

      <el-form-item
          label="File Reception Date To"
          style="width:600px;"
      >
        <el-date-picker
          format="dd/MM/yyyy"
          v-model="formValue.fileReceptionDateTo"
        ></el-date-picker>
      </el-form-item>



      <el-form-item>
        <base-button class="mt-3" native-type="submits" type="primary" @click.prevent="search" style="color: #313e5e !important; border: 0.2px solid #313e5eb!important">
          Search
        </base-button>
      </el-form-item>
    </el-form>

    <search-result
      v-else-if="!hasSelectUserDocResult"
      :tableData="searchResult"
      :backToSearch="backToSearch"
    />


  </card>
</template>

<script>
import api from './api';
import helpers from '../../util/helpers'
import SearchResult from './searchResult.vue'
import {
  Card,
  Checkbox,
  Form,
  FormItem,
  Input,
  Select,
  Button,
  Option,
  Message,
  DatePicker
  } from 'element-ui';
export default {
  data() {
    return {
      result: {},
      labelPosition: 'left',
      formLabelAlign: {
        name: '',
        region: '',
        type: ''
      },
      master: {
        fileSequence: '',
        fileType: '',
        applSubType: ''
      },
      formValue: {
        fileSequence: '',
        fileType: '',
        fileSer: '',
        fileNbr: '',
        fileNbrRange: '',
        fileNbrTo: '',
        applSubType: '',
        applType: '',
        fileFilingDateRange: '',
        fileFilingDateTo: '',
        fileReceptionDateRange: '',
        fileReceptionDateTo: ''
      },
      formValueDescMapping: {
        fileSequence: 'File Sequence ',
        fileType: 'File Type ',
        fileSer: 'File Series ',
        fileNbr: 'File Number ',
        fileNbrRange: 'File Number >',
        fileNbrTo: 'File Number <',
        applSubType: 'Application Sub Type ',
        applType: 'Application Type ',
        fileFilingDateRange: 'File Filing Date >',
        fileFilingDateTo: 'File Filing Date <',
        fileReceptionDateRange: 'File Reception Date >',
        fileReceptionDateTo: 'File Reception Date <',
        _types: 'Application Sub Type '
      },
      searchResult: [],
      isLoading: false
    }
  },
  components : {
    [Checkbox.name]: Checkbox,
    [Checkbox.name]: Checkbox,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Select.name]: Select,
    [Card.name]: Card,
    [Button.name]: Button,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    SearchResult,
    Message
  },
  computed: {
    payloadForSearch() {
      const {
        fileFilingDateRange,
        fileFilingDateTo,
        fileReceptionDateRange,
        fileReceptionDateTo,
        applSubType
      } = this.formValue

      const _applType = applSubType.split('///')[0]
      const _applSubType = applSubType.split('///')[1]
      const _fileFilingDateRange = helpers.getDateIndonesiaFormat(fileFilingDateRange)
      const _fileFilingDateTo = helpers.getDateIndonesiaFormat(fileFilingDateTo)
      const _fileReceptionDateRange = helpers.getDateIndonesiaFormat(fileReceptionDateRange)
      const _fileReceptionDateTo = helpers.getDateIndonesiaFormat(fileReceptionDateTo)
      const _types = applSubType && [_applType, _applSubType]

      return {
        ...this.formValue,
        fileFilingDateRange: _fileFilingDateRange,
        fileFilingDateTo: _fileFilingDateTo,
        fileReceptionDateRange: _fileReceptionDateRange,
        fileReceptionDateTo: _fileReceptionDateTo,
        applSubType: _applType,
        applType: _applSubType,
        _types

      }
    },
    hasSearchResult() {
      return this.searchResult.length > 0
    },
    title() {
      if (!this.hasSearchResult) return 'Enter userdoc selection criteria'
      return 'Select User Doc'
    },
    queryParams() {
      const payloadForSearch = {...this.payloadForSearch}
      const arr = []

      Object.keys(payloadForSearch).map(key => {
        payloadForSearch[key] && arr.push({
          name: key,
          value: payloadForSearch[key]
        })
      })

      const str = arr.map(f => {
        return `${f.name}=${f.value}`
      })

      return str.join('&')
    },

    queryInfo() {
      const payloadForSearch = {...this.payloadForSearch}
      delete payloadForSearch.applType
      delete payloadForSearch.applSubType
      const arr = []
      const {
        fileSequence,
        fileType,
        applSubType
      } = this.master

      const {
        fileFilingDateRange,
        fileFilingDateTo,
        fileReceptionDateRange,
        fileReceptionDateTo
      } = this.formValue

      Object.keys(payloadForSearch).map(key => {
        let value =  payloadForSearch[key]

        if (key === 'fileType' && fileType) {
          const filtered = fileType.filter(ft => ft.FileType === value)[0]
          value = filtered && filtered.FileTypeName
        }
        if (key === 'fileSequence' && fileSequence) {
          const filtered = fileSequence.filter(fs => fs.FileSeq === value)[0]
          value = filtered && filtered.FileSeqName
        }
        if (key === '_types' && applSubType) {
          const filtered = applSubType.filter(tp => tp.ApplTyp === value[0] && tp.ApplSubTyp === value[1])[0]
          value = filtered && filtered.ApplSubTypName
        }
        if (key === 'fileFilingDateRange' && fileFilingDateRange) {
          value = helpers.getShortDateIndonesiaFormat(fileFilingDateRange)
        }
        if (key === 'fileFilingDateTo' && fileFilingDateTo) {
          value = helpers.getShortDateIndonesiaFormat(fileFilingDateTo)
        }
        if (key === 'fileReceptionDateRange' && fileReceptionDateRange) {
          value = helpers.getShortDateIndonesiaFormat(fileReceptionDateRange)
        }
        if (key === 'fileReceptionDateTo' && fileReceptionDateTo) {
          value = helpers.getShortDateIndonesiaFormat(fileReceptionDateTo)
        }

        payloadForSearch[key] && arr.push({
          name: key,
          label: this.formValueDescMapping[key],
          value
        })
      })

      const str = arr.map(f => {
        return `${f.label}= ${f.value}`
      })

      return str.join(', ')
    }
  },
  mounted() {
    this.getMasterData()
  },
  methods: {
    async getMasterData() {
      try {
        this.isLoading = true
        const applSubType = await api.getMaster('applSubType')
        const fileSequence = await api.getMaster('fileSequence')
        const fileType = await api.getMaster('fileType')
        this.master= {
          fileSequence: fileSequence.data || [],
          fileType: fileType.data || [],
          applSubType: applSubType.data || [],
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async search () {
      try {
        this.isLoading = true
        this.searchValidation()
        const result = await api.search(this.queryParams)
        if (result.data.length === 0) {
          Message.warning({
            message: 'No record',
            duration: 10000,
            showClose: true
          });
          return 0;}
        this.searchResult = result.data
        if (result.err) throw new Error(result.err)
      } catch (error) {
        console.dir(error)
        Message.error({
            message: error.response ? error.response.data.message : error,
            duration: 10000,
            showClose: true
        })
      } finally {
        this.isLoading = false
      }
    },
    searchValidation() {
      // if(!this.formValue.fileSequence) throw new Error('Please specify File Sequence')
      // if(!this.formValue.fileFilingDateRange && this.formValue.fileFilingDateTo ) throw new Error('Please specify file Filing Date Range')
      // if(this.formValue.fileFilingDateRange && !this.formValue.fileFilingDateTo ) throw new Error('Please specify file Filing Date To')
      // if(!this.formValue.fileReceptionDateRange && this.formValue.fileReceptionDateTo ) throw new Error('Please specify file Reception Date Range')
      // if(this.formValue.fileReceptionDateRange && !this.formValue.fileReceptionDateTo ) throw new Error('Please specify file Reception Date To')
    },
    backToSearch() {
      this.searchResult = []
    }
  }
}
</script>
